var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.706 8.318c0 3.196-2.6 5.796-5.797 5.796a5.8 5.8 0 01-5.752-5.072.497.497 0 11.985-.123 4.805 4.805 0 009.57-.601 4.808 4.808 0 00-4.803-4.803 4.769 4.769 0 00-2.967 1.027h.625a.497.497 0 010 .994H3.694a.497.497 0 01-.497-.497V3.165a.497.497 0 01.993 0v.714a5.748 5.748 0 013.72-1.358c3.195 0 5.796 2.6 5.796 5.797zM7.949 5.17a.497.497 0 00-.497.497v.184A1.486 1.486 0 006.135 7.48c.08.776.791 1.335 1.57 1.335h.575a.497.497 0 010 .993H7.122a.497.497 0 000 .994h.33v.166a.497.497 0 00.994 0v-.189c.674-.106 1.247-.622 1.317-1.312A1.492 1.492 0 008.28 7.821h-.662a.497.497 0 010-.994H8.78a.497.497 0 000-.993h-.334v-.166a.497.497 0 00-.497-.497z",
    fill: "#9390A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackIcon);
export default __webpack_public_path__ + "static/media/cashback-icon.49aa56ed58b48505e9144428ed495709.svg";
export { ForwardRef as ReactComponent };